import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  onClick?: () => void
}

const AsideMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  onClick,
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config

  return (
    <div className='w-full'>
      <Link
        to={to}
        onClick={onClick}
        className={clsx(
          'flex items-center gap-3 w-full px-4 py-2 rounded transition font-semibold text-white hover:bg-gray-700 hover:text-teal-300',
          {
            'bg-gray-800 text-teal-300': isActive,
          }
        )}
      >
        {hasBullet && <span className='text-sm text-teal-400'>•</span>}

        {icon && aside.menuIcon === 'svg' && (
          <span className='w-5 h-5'>
            <KTSVG path={icon} className='w-full h-full' />
          </span>
        )}

        {fontIcon && aside.menuIcon === 'font' && (
          <i className={clsx('bi text-lg', fontIcon)}></i>
        )}

        <span className='text-sm'>{title}</span>
      </Link>

      {children}
    </div>
  )
}

export {AsideMenuItem}
